(function () {
  'use strict';

  /* ============ Couverture : glisser pour ouvrir ============ */
  function initCover() {
    var cover = document.getElementById('carnet-cover');
    var page = document.getElementById('carnet-cover-page');
    var selection = document.getElementById('carnet-selection');
    if (!cover || !page) return;

    var startX = null;

    function open() {
      page.classList.add('is-open');
      setTimeout(function () {
        cover.classList.add('is-hidden');
        if (selection) selection.classList.add('is-visible');
      }, 900);
    }

    page.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    page.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var endX = e.changedTouches[0].clientX;
      if (startX - endX > 50) open();
      startX = null;
    }, { passive: true });

    page.addEventListener('click', open);
  }

  /* ============ Sélection : choisir un carnet ============ */
  function initSelection() {
    var selection = document.getElementById('carnet-selection');
    if (!selection) return;

    var cards = Array.prototype.slice.call(selection.querySelectorAll('[data-target-carnet]'));

    function showCarnet(key) {
      selection.classList.remove('is-visible');
      selection.classList.add('is-hidden');

      var target = document.querySelector('[data-carnet-catalogue][data-carnet-key="' + key + '"]');
      if (!target) return;

      document.querySelectorAll('.carnet-catalogue-instance.is-active').forEach(function (el) {
        if (el !== target) el.classList.remove('is-active');
      });

      target.classList.add('is-active');
      ensureCatalogueInitialized(target);
      window.scrollTo({ top: 0 });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        showCarnet(card.getAttribute('data-target-carnet'));
      });
    });

    document.body.addEventListener('click', function (e) {
      var backBtn = e.target.closest('[data-back-to-selection]');
      if (!backBtn) return;
      document.querySelectorAll('.carnet-catalogue-instance.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      selection.classList.remove('is-hidden');
      selection.classList.add('is-visible');
      window.scrollTo({ top: 0 });
    });
  }

  /* ============ Catalogue : navigation entre feuilles (par instance) ============ */
  var initializedCatalogues = new WeakSet();

  function ensureCatalogueInitialized(root) {
    if (initializedCatalogues.has(root)) return;
    initializedCatalogues.add(root);

    var wraps = Array.prototype.slice.call(root.querySelectorAll('.carnet-catalogue__leaf-wrap'));
    if (wraps.length === 0) return;

    var current = 0;
    var dotTrack = root.querySelector('[data-dot-track]');

    if (dotTrack) {
      wraps.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'carnet-dot' + (i === 0 ? ' is-active' : '');
        dotTrack.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotTrack) return;
      Array.prototype.forEach.call(dotTrack.children, function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function showLeaf(index, direction) {
      if (index < 0 || index >= wraps.length || index === current) return;

      var outgoing = wraps[current];
      var incoming = wraps[index];

      incoming.removeAttribute('data-hidden');
      incoming.classList.remove('is-turning-next', 'is-turning-prev');
      incoming.style.zIndex = 25;

      void outgoing.offsetWidth;
      outgoing.classList.add(direction === 'next' ? 'is-turning-next' : 'is-turning-prev');

      setTimeout(function () {
        outgoing.setAttribute('data-hidden', 'true');
        outgoing.classList.remove('is-turning-next', 'is-turning-prev');
        outgoing.style.zIndex = '';
        incoming.style.zIndex = '';
      }, 780);

      current = index;
      updateDots();
    }

    var startX = null;
    root.addEventListener('touchstart', function (e) {
      if (e.target.closest('select, button, input, a')) { startX = null; return; }
      startX = e.touches[0].clientX;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var endX = e.changedTouches[0].clientX;
      var delta = startX - endX;
      if (delta > 60) showLeaf(current + 1, 'next');
      else if (delta < -60) showLeaf(current - 1, 'prev');
      startX = null;
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-active')) return;
      if (e.key === 'ArrowLeft') showLeaf(current - 1, 'prev');
      if (e.key === 'ArrowRight') showLeaf(current + 1, 'next');
    });
  }

  /* ============ Panier Shopify natif (Ajax API) ============ */
  function updateCartCount(count) {
    var el = document.getElementById('carnet-cart-count');
    if (el) el.textContent = count;
  }

  function addToCart(variantId, feedbackEl) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (feedbackEl) feedbackEl.textContent = 'Ajouté au panier ✓';
        return cart;
      })
      .catch(function (err) {
        if (feedbackEl) feedbackEl.textContent = (err && err.description) || 'Une erreur est survenue.';
        throw err;
      });
  }

  function initPurchaseButtons() {
    document.body.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-add-to-cart]');
      var buyBtn = e.target.closest('[data-buy-now]');
      if (!addBtn && !buyBtn) return;

      var leaf = e.target.closest('.carnet-leaf');
      if (!leaf) return;
      var select = leaf.querySelector('[data-variant-select]');
      var feedback = leaf.querySelector('[data-cart-feedback]');
      var variantId = select ? select.value : null;
      if (!variantId) return;

      var btn = addBtn || buyBtn;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '…';

      addToCart(variantId, feedback)
        .then(function () {
          if (buyBtn) {
            window.location.href = '/checkout';
          } else {
            btn.textContent = originalText;
            btn.disabled = false;
          }
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  /* ============ Page panier : retirer un produit ============
     Utilise l'API Ajax officielle /cart/change.js avec l'index de
     ligne (position dans cart.items, en partant de 1) et quantity: 0,
     qui est la methode fiable et documentee pour retirer une ligne
     precise du panier, plutot que de compter sur la saisie manuelle
     d'une quantite a 0 dans le champ nombre. */
  function initCartPage() {
    var table = document.querySelector('.carnet-cart-table');
    if (!table) return;

    table.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      e.preventDefault();

      var line = btn.getAttribute('data-line');
      if (!line) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '…';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          // Le plus simple et le plus fiable pour reafficher un panier
          // a jour (recalcul des totaux, disparition de la ligne,
          // eventuel message "panier vide") est de recharger la page
          // panier apres confirmation du retrait cote serveur.
          window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCover();
    initSelection();
    initPurchaseButtons();
    initCartPage();
    document.querySelectorAll('.carnet-catalogue--single[data-carnet-catalogue]').forEach(function (root) {
      root.classList.add('is-active');
      ensureCatalogueInitialized(root);
    });
  });
})();
